import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { FC } from "react";
import { MuiBox, MuiButtonTertiary } from "../../../../components";
import MuiEllipseLabel from "../../../../components/ellipseLabel/MuiEllipseLabel";
import { useSiteCore } from "../../../../hooks/useSiteCore";

import { BULK_TYPE, SummaryStatus } from "../../../../helpers/constants";
import { RecordStats } from "../../../../helpers/types/common";
import { bulkTransferSiteCoreKeys } from "../../siteCore/SiteCoreKeys";

import {
  SUMMARY_CARD_TYPE,
  SummaryCard,
} from "../../../createBulkActivity/components/summaryCard/SummaryCard";
import {
  BulkActivityCardsWrapper,
  BulkTransferStatusPanelWrapper,
  HorizontalLine,
  VerticalDivider,
} from "./BulkTransferStatusPanel.style";

export interface BulkTransferStatusPanelProps {
  recordStatistics: RecordStats;
  processName: string;
  status: string;
  onRefresh?: () => void;
}

export const BulkTransferStatusPanel: FC<BulkTransferStatusPanelProps> = ({
  status,
  recordStatistics,
  processName,
  onRefresh,
}) => {
  const { useFetchLabel } = useSiteCore();

  const { bulkParticipantSummary, refreshStatusLink } = bulkTransferSiteCoreKeys;

  const getLabel = useFetchLabel(bulkParticipantSummary);

  return (
    <BulkTransferStatusPanelWrapper>
      <MuiBox>
        <MuiEllipseLabel
          text={processName}
          labelTypoVariant="h3Bold"
          labelTypoClassName="label-name-value"
        />
      </MuiBox>

      <BulkActivityCardsWrapper>
        <SummaryCard
          type={SUMMARY_CARD_TYPE.totalNumberOfPrograms}
          count={recordStatistics.total.count}
          label={recordStatistics.total.label}
          bulkType={BULK_TYPE.TRANSFER}
        />
        <VerticalDivider />
        <SummaryCard
          type={SUMMARY_CARD_TYPE.processed}
          count={recordStatistics.processed.count}
          label={recordStatistics.processed.label}
          bulkType={BULK_TYPE.TRANSFER}
        />

        {recordStatistics.unprocessed && (
          <>
            <VerticalDivider />
            <SummaryCard
              type={SUMMARY_CARD_TYPE.unprocessed}
              count={recordStatistics.unprocessed.count}
              label={recordStatistics.unprocessed.label}
              bulkType={BULK_TYPE.TRANSFER}
            />
          </>
        )}
      </BulkActivityCardsWrapper>
      <HorizontalLine />
      {status === SummaryStatus.PROCESSING && onRefresh && (
        <MuiButtonTertiary
          data-testid={"summary-button-testId"}
          onClick={onRefresh}
        >
          <RefreshOutlinedIcon />
          {getLabel(refreshStatusLink)}
        </MuiButtonTertiary>
      )}
    </BulkTransferStatusPanelWrapper>
  );
};
